import type { CategoryFilterState } from '@/types';

export const buildFilterQuery = (
  page: number,
  { sort, inStock, selectedFacets }: CategoryFilterState,
): Record<string, string> => {
  const query: Record<string, string> = {
    page: String(page),
    sort,
    instock: String(inStock),
  };
  for (const [group, keys] of Object.entries(selectedFacets)) {
    if (keys.length > 0) {
      query[group] = keys.join(';');
    }
  }
  return query;
};
